<template>
  <div>
    <div class="page-head"><div><h1>门店总览</h1><p>今天的课程、预约与时长余额</p></div><el-button type="primary" icon="el-icon-plus" @click="$router.push('/classes')">管理课程</el-button></div>
    <el-row :gutter="16">
      <el-col v-for="item in cards" :key="item.label" :span="6"><div class="metric"><small>{{ item.label }}</small><strong>{{ item.value }}</strong><span>{{ item.hint }}</span></div></el-col>
    </el-row>
    <div class="panel" style="margin-top:20px"><h3>近期课程</h3>
      <el-table :data="upcoming" v-loading="loading" style="width:100%">
        <el-table-column prop="start_at" label="上课时间" width="190" />
        <el-table-column prop="title" label="课程" min-width="180" />
        <el-table-column prop="teacher" label="老师" width="130" />
        <el-table-column label="预约"><template slot-scope="{row}">{{ row.booked_count }} / {{ row.capacity }}</template></el-table-column>
        <el-table-column label="操作" width="120"><template slot-scope="{row}"><el-button size="mini" @click="$router.push({path:'/bookings',query:{classId:row.id}})">查看名单</el-button></template></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { dashboard, listClasses } from '../api'
export default {
  data: () => ({ stats: {}, upcoming: [], loading: false }),
  computed: {
    cards () {
      return [
        { label: '今日课程', value: this.stats.today_classes || 0, hint: '节已排课程' },
        { label: '今日预约', value: this.stats.today_bookings || 0, hint: '人次预约' },
        { label: '已签到', value: this.stats.today_checked_in || 0, hint: '今日到课' },
        { label: '时长不足', value: this.stats.low_credit_members || 0, hint: '剩余 3 小时及以下' }
      ]
    }
  },
  async created () {
    this.loading = true
    try {
      const [stats, classes] = await Promise.all([dashboard(), listClasses()])
      this.stats = stats
      this.upcoming = classes.filter(item => item.status === 'active' && new Date(item.start_at.replace(/-/g, '/')) >= new Date()).reverse().slice(0, 6)
    } catch (e) { this.$message.error(e.message) } finally { this.loading = false }
  }
}
</script>
<style scoped>
.metric { background: #fff; border: 1px solid #e8e4dd; border-radius: 12px; padding: 25px; min-height: 140px; box-shadow: 0 8px 26px rgba(39,51,52,.03); }
.metric small, .metric span { display: block; color: #89938f; font-size: 12px; }
.metric strong { display: block; color: #263439; font-family: Georgia, "Songti SC", serif; font-size: 34px; font-weight: 500; margin: 17px 0 6px; }
h3 { margin-top: 0; color: #263439; font-size: 17px; }
</style>
